import React, { useState, useContext, useEffect } from "react";
import { ProductOptionStepsContext } from "../../../../Providers/ProductOptionStepsProvider";
import ReactCrop from "react-image-crop";
import styled from "styled-components";
import "react-image-crop/dist/ReactCrop.css";
import { transparentize } from "polished";

const StyledReactCrop = styled(ReactCrop)`
    border: 1px solid #dddddd;
    //width: 100%;
    ${props =>
        props.bleed &&
        `
    .ReactCrop__crop-selection {
        -webkit-box-shadow: inset 0px 0px 0px 10px ${transparentize(
            0.3,
            "red"
        )}, 0 0 0 9999em rgba(0, 0, 0, 0.5);
        -moz-box-shadow: inset 0px 0px 0px 10px ${transparentize(
            0.3,
            "red"
        )}, 0 0 0 9999em rgba(0, 0, 0, 0.5);
        box-shadow: inset 0px 0px 0px 10px ${transparentize(
            0.3,
            "red"
        )}, 0 0 0 9999em rgba(0, 0, 0, 0.5);
    }
    `}

    .ReactCrop__image {
        width: ${props =>
            props.width ? props.width + "px" : "auto"} !important;
        max-width: 600px !important;
        max-height: 100% !important;
    }
`;

const CropTool = ({ files, setCroppedImageUrl, bleed, containerRef }) => {
    const { onGetAspectRatio, steps } = useContext(ProductOptionStepsContext);

    const [src, setSrc] = useState(null);
    const [crop, setCrop] = useState({
        aspect: 1,
        width: 50,
        x: 0,
        y: 0
    });
    const [imageRef, setImageRef] = useState(null);
    const [pixelCrop, setPixelCrop] = useState(null)
    const [first, setFirst] = useState(true)
    useEffect(() => {
        const ratio = onGetAspectRatio(steps);
        setCrop({
            ...crop,
            aspect: ratio,
            x: 0,
            y: 0,
            height: 30,
            width: 30
        });
    }, [steps]);

    useEffect(() => {
        if(pixelCrop && crop && imageRef){
            if(first){
                onCropComplete(crop, pixelCrop)
                setFirst(false)
            }
        }
    }, [pixelCrop, crop, imageRef])

    useEffect(() => {
        if (files.length > 0) {
            setSrc(`data:image/jpg;base64, ${files[0].thumb}`);
        }
    }, [files]);

    const onImageLoaded = (image, pixelCrop) => {
        setPixelCrop(pixelCrop)
        setImageRef(image);
    };

    const onCropComplete = (crop, pixelCrop) => {
        makeClientCrop(crop, pixelCrop);
    };

    const onCropChange = crop => {
        setCrop(crop);
    };

    const makeClientCrop = async (crop, pixelCrop) => {
        if (imageRef && crop.width && crop.height) {
            const croppedImageUrl = await getCroppedImg(
                imageRef,
                pixelCrop,
                "newFile.jpeg"
            );
            setCroppedImageUrl(croppedImageUrl);
        }
    };

    const getCroppedImg = (image, pixelCrop, fileName) => {
        const canvas = document.createElement("canvas");
        canvas.width = pixelCrop.width;
        canvas.height = pixelCrop.height;
        const ctx = canvas.getContext("2d");

        ctx.drawImage(
            image,
            pixelCrop.x,
            pixelCrop.y,
            pixelCrop.width,
            pixelCrop.height,
            0,
            0,
            pixelCrop.width,
            pixelCrop.height
        );
   
            return new Promise((resolve, reject) => {
                canvas.toBlob(blob => {
                    if (!blob) {
                        //reject(new Error('Canvas is empty'));
                        console.error("Canvas is empty");
                        return;
                    }
                    blob.name = fileName;
    
                    let fileUrl;
                    window.URL.revokeObjectURL(fileUrl);
                    fileUrl = window.URL.createObjectURL(blob);
                    resolve(fileUrl);
                }, "image/jpeg");
            });
       
    
    };

    return (
        <>
            {src && (
                <StyledReactCrop
                    width={
                        containerRef &&
                        containerRef.current &&
                        containerRef.current.clientWidth
                    }
                    bleed={bleed}
                    src={src}
                    crop={crop}
                    onImageLoaded={onImageLoaded}
                    onComplete={onCropComplete}
                    onChange={onCropChange}
                />
            )}
        </>
    );
};

export default CropTool;

// function dataURItoBlob(dataURI) {
//     // convert base64 to raw binary data held in a string
//     // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
//     var byteString = atob(dataURI.split(',')[1]);
  
//     // separate out the mime component
//     var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]
  
//     // write the bytes of the string to an ArrayBuffer
//     var ab = new ArrayBuffer(byteString.length);
  
//     // create a view into the buffer
//     var ia = new Uint8Array(ab);
  
//     // set the bytes of the buffer to the correct values
//     for (var i = 0; i < byteString.length; i++) {
//         ia[i] = byteString.charCodeAt(i);
//     }
  
//     // write the ArrayBuffer to a blob, and you're done
//     var blob = new Blob([ab], {type: mimeString});
//     return blob;
  
//   }